"use client";
import React, { useContext } from "react";
import { motion } from "framer-motion";
import { ProductContext } from "../../context/ProductContext"; // ✅ adjust path if needed

const ProductSpecs = () => {
  const { product, loading } = useContext(ProductContext);

  if (loading) {
    return (
      <p className="text-center text-gray-500 mt-10">
        Loading product specs...
      </p>
    );
  }

  if (!product) {
    return (
      <p className="text-center text-red-500 mt-10">Product not found.</p>
    );
  }

  // ✅ Safe check for details
  const details = Array.isArray(product.details) ? product.details : [];

  // Separate Age Range if exists
  const ageRangeDetail = details.find(
    (d) => d.label?.toLowerCase() === "age range"
  );
  const otherDetails = details.filter(
    (d) => d.label?.toLowerCase() !== "age range"
  );

  return (
    <motion.section
      className="mt-10"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
    >
      {ageRangeDetail && (
        <div>
          <h3 className="self-start text-lg font-semibold tracking-wide text-sky-950">
            {ageRangeDetail.label}
          </h3>
          <p className="self-start mt-4 text-base text-gray-800">
            {ageRangeDetail.value}
          </p>
        </div>
      )}

      <hr className="shrink-0 mt-4 w-full h-px border border-black border-solid" />

      <div className="mt-4">
        <h3 className="self-start text-lg font-semibold tracking-wide text-sky-950">
          Product Details
        </h3>
        <ul className="mt-4 space-y-2 text-base text-gray-800">
          {otherDetails.length > 0 ? (
            otherDetails.map((detail, index) => (
              <li key={detail.id}>
                {index + 1}. {detail.label}: {detail.value}
              </li>
            ))
          ) : (
            <li className="text-gray-500 italic">No extra details available.</li>
          )}
        </ul>
      </div>

      <p className="self-start mt-4 text-base italic tracking-normal underline text-stone-900 max-md:max-w-full">
        Additional Delivery Charges to other Emirates will be applied.
      </p>

      <div className="flex gap-2 self-start mt-4">
        <span className="text-base font-medium text-neutral-800">Note:</span>
        <span className="flex-auto text-sm text-gray-800">
          Additional VAT is applicable on all products
        </span>
      </div>
    </motion.section>
  );
};

export default ProductSpecs;
